<template>
  <div class="position-relative mt-3" id="acordMappingTable">

    <div class="actions text-right" id="acordMappingTable-showAddEditDialog">
      <button class="btn btn-primary icon-button" @click="showAddEditDialog = true" id="acordMappingTable-add-Button">
        <span class="btn-icon" id="acordMappingTable-addButton-span"><i class="fa fa-plus" aria-hidden="true"
            id="acordMappingTable-addButton-data"></i></span>
        {{ 'ADD' | translate }}
      </button>
    </div>

    <vodal :show="showAddEditDialog" :width="400" :closeOnEsc="true" :closeOnClickMask="false"
      :customStyles="{ 'top': '80px', 'bottom': 'auto', 'height': 'auto' }" animation="rotate" @hide="closeDialog">
      <acord-mapping-add-edit-dialog :edited="editedRow" :insurers="insurers" :productlines="productlines"
        :products="products" @save="onSaveNew" @update="onUpdate" @close="closeDialog"
        id="acordMappingTable-addEditDialog"></acord-mapping-add-edit-dialog>
    </vodal>
    <table class="table table-striped table-hover" id="acordMappingTable-tableData">
      <caption></caption>
      <tr>
        <th>Maatschappij</th>
        <th>Branche</th>
        <th>productname</th>
        <th>extCoverageTypeCd</th>
        <th>premium Field</th>
      </tr>
      <template v-for="row in rows">
        <tr>
          <td>{{ row.insurerName }}</td>
          <td>{{ row.productLineName }}</td>
          <td>{{ row.productName }} </td>
          <td>{{ row.extCoverageTypeCd }}</td>
          <td>{{ row.premiumField }}</td>
          <td id="acordMappingTable-tableButtons">
            <button class="btn btn-success icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('EDIT')" @click="onEdit(row)"
              :id="'acordMappingTable-tableEditButton-' + row.name">
              <span class="btn-icon" :id="'acordMappingTable-tableEditSpan-' + row.name"><i class="fa fa-pencil"
                  aria-hidden="true" :id="'acordMappingTable-tableEditData-' + row.name"></i></span>
            </button>
            <button class="btn btn-danger icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('DELETE')" @click="confirmDelete(row)"
              :id="'acordMappingTable-tableDeleteButton-' + row.name">
              <span class="btn-icon" :id="'acordMappingTable-tableDeleteSpan-' + row.name"><i class="fa fa-trash-o"
                  aria-hidden="true" :id="'acordMappingTable-tableDeleteData-' + row.name"></i></span>
            </button>
          </td>
        </tr>
      </template>
    </table>
    <confirm-dialog :show="showDeleteConfirmDialog" :textLabel="'Are you sure you want to delete this?'"
            @hide-dialog="showDeleteConfirmDialog = false" @confirm="onRemove(selectedRow.id)">
            </confirm-dialog>
  </div>
</template>

<script>
import RestService from '../../../service/RestService.js';
import AcordMappingAddEditDialog from './AcordMappingAddEditDialog.vue';
import Datepicker from 'vuejs-datepicker';
import Vodal from 'vodal';
import ConfirmDialog from '../../dialog/ConfirmDialog.vue';

export default {
  components: { AcordMappingAddEditDialog, Datepicker, Vodal, ConfirmDialog },
  data() {
    return {
      rest: this.initRestService(),
      filter: '',
      rows: [],
      newRows: [],
      editedRow: null,
      productlines: [],
      products: [],
      insurers: [],
      showAddEditDialog: false,
      showDeleteConfirmDialog: false,
      selectedRow: null
    }
  },
  beforeMount() {
    this.loadRows();
    this.loadInsurers();
    this.loadProductlines();
    this.loadProducts();
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async loadRows() {
      const acordMappingResponse = await this.rest.getAllAcordMappingRows();
      this.rows = acordMappingResponse.data;
    },
    async loadProductlines() {
      const productlinesResponse = await this.rest.getAllProductlineRows();
      this.productlines = productlinesResponse.data;
    },
    async loadInsurers() {
      const insurerNamesResponse = await this.rest.getAllInsurerNames();
      this.insurers = insurerNamesResponse.data;
    },
    async loadProducts() {
      const productsResponse = await this.rest.getAllProductRows();
      this.products = productsResponse.data;
    },
    async onSaveNew(row) {
      await this.rest.createAcordMappingRow(row);
      this.closeDialog();
      this.loadRows();
    },
    async onUpdate(row) {
      await this.rest.updateAcordMappingRow(row);
      this.closeDialog();
      this.loadRows();
    },
    onEdit(row) {
      this.editedRow = { ...row };
      this.showAddEditDialog = true;
    },
    onRemove(rowId) {
      this.rows = this.rows.filter(row => row.id !== rowId);
      this.rest.deleteAcordMappingRow(rowId);
      this.showDeleteConfirmDialog = false;
    },
    closeDialog() {
      this.showAddEditDialog = false;
      this.editedRow = false;
    },
    confirmDelete(row) {
      this.selectedRow = row;
      this.showDeleteConfirmDialog = true;
    }
  }
}
</script>

<style lang="scss" scoped>
>>>.vue-table {
  border: 0;

  th,
  td {
    border-right: 0;
    border-bottom: 0;
    border-left: 0;
  }

  thead>tr>th {
    padding-right: .75rem;
    padding-left: 30px !important;
  }

  .arrow:before {
    bottom: 12px;
    right: auto;
    left: 12px;
    font-family: 'FontAwesome';
  }

  .icon-button {
    opacity: 0;
    transition: opacity .1s ease-out;
  }

  tr:hover .icon-button {
    opacity: 1;
  }
}

.actions {
  position: absolute;
  z-index: 1;
  top: 10px;
  right: 0;

  .icon-button {
    padding-right: 15px;
    padding-left: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/acord-mapping/AcordMappingTable.vue